<div class="topdiv">
    <label i18n="@@spmsUserReg" class="textColour" title="Headers Selection" >Headers Selection</label>
 
         
  
        <div class="row" >
            <div class="col-lg-2">

            </div>
          <div class="col-lg-4">
            <div class="seperateDiv" style=" overflow: hidden; flex-grow: 1;" >
              <ag-grid-angular class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin" style="width: 100%;" [columnDefs]="columnDefsForObjects"  [animateRows]="true"  [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowMultiSelectWithClick]="false"
                [rowSelection]="rowSelection" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45" [enableRangeSelection]="true" [debug]="true"
                (gridReady)="onGridReadyForObjects($event,'insert')" (rowSelected)="cellClickedObjects($event)" (rowDoubleClicked)="pushDataToSelectedFieldsGrid()" [hidden]="!true" >
              </ag-grid-angular>
            </div>
          </div>

          <div style="width: 2%;margin: initial;font-size: 1.8rem;text-align: center;">
            <div style="    margin-top: 150px;" title="Move selected row to right">
              <div (click)="pushDataToSelectedFieldsGrid()">
                <em class="fas fa-step-forward"></em>
              </div>
              <div (click)="popDataToSelectedFieldsGrid()" title="Move selected row to left">
                <em class="fas fa-step-backward"></em>
              </div>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="seperateDiv" >
              <ag-grid-angular class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin"  [columnDefs]="columnDefsForSelectedFields"  [animateRows]="true"  [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowMultiSelectWithClick]="false"
              [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45" [enableRangeSelection]="true" [debug]="true" [components]="components"
              (gridReady)="onGridReadyForSelectedTableFields($event,ngModelObjectTemporary)" (rowSelected)="onRowSelectedToRemove($event)" (rowDoubleClicked)="popDataToSelectedFieldsGrid()" [hidden]="!true">
              </ag-grid-angular>
            </div>
          </div>

          <div class="col-lg-2">

        </div>
        </div>
  
<!--   
        <div class="row mb-1 topRowMargins" style= "position:sticky;left:0;bottom:0;width:100%;background-color: #fff; ">
          <div class="col-lg text-center">
            <div style="text-align: end;">
              <form novalidate [formGroup]="formValidCheckbox">
                <span *ngIf='buttonName=="Save"'>
                 
                </span>
  
                <div style="margin-left:2%;margin-right:2%">

                  
                      <div class="container" style="text-align: center;">
                        <div class="row topRowMargins">
                          
                            <button i18n="@@TMRunButton" type="button" (click)="save()" [style.background-color]="buttonColor"
                            class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;font-size: .85rem;width:100%;">Save</button>
                          
                          
                            <button i18n="@@TMRunButton" type="button" (click)="cancel()" [style.border-color]="buttonColor"
                            class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;font-size: .85rem;width:100%;">Cancel</button>
                          
                         
                        </div>
                      </div>
                   
                  </div>
  
              </form>
            </div>
          </div>
        </div> -->
        
        <div class="row mb-1 topRowMargins" style= "left:0;bottom:0;width:100%;background-color: #fff; ">
          <div class="col-lg text-center">
            <div style="text-align: end">
              <form novalidate [formGroup]="formValidCheckbox">
                <span *ngIf='buttonName=="Save"'>
                 
                </span>
  
                <!-- <button i18n="@@TMRunButton" [disabled]="!validations_form.valid"  type="button" (click)="save()" class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                style="padding-left:1.2rem;padding-right: 1.2rem" [style.background-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean">Save</button>
  
  
                <button i18n="@@TMRunButton" type="button" (click)="cancel()" class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                style="padding-left:1.2rem;padding-right: 1.2rem" [style.border-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean" >Cancel</button> -->
                <button i18n="@@TMRunButton" type="button" title="Save" (click)="save()" [style.background-color]="buttonColor"
                class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;font-size: .85rem;">Save</button>
              
              
                <button i18n="@@TMRunButton" type="button" title="Cancel" (click)="cancel()" [style.border-color]="buttonColor"
                class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;font-size: .85rem;">Cancel</button>
  
              </form>
            </div>
          </div>
        </div>
  </div>
  
  
